// @flow

import ko from 'rgs-knockout';

import { Validatable } from 'validatable';

import vb from 'validation-builder';

import { JSableOmitPrivateMixin } from 'jsable';

import { observableJSableMobilePhone } from 'observable-mobile-phone';

import { actions } from '../dictionary';

import type { IDataModel, DataModelOptions } from '../contracts';

export default class BaseDataModel
	extends JSableOmitPrivateMixin(Validatable)
	implements IDataModel {
	constructor (options: DataModelOptions) {
		super(options);

		this._options = options;

		this.busy = options.busy;

		this.actions = actions;

		this.Phone = observableJSableMobilePhone()
			.extend({
				validation: vb.all([
					vb.required(true, 'введите номер телефона'),
					vb.phone11Digits(),
				]),
			});

		this.Code = ko.map(ko.observable(), {
			mapWrite: v => {
				this.Code.clearError();
				return v;
			},
		})
			.extend({
				validation: vb.all([
					vb.required(true, 'введите код'),
				]),
			})
			.extend({ toJS: true });

		this.Key = ko.observable()
			.extend({ toFromJS: true });

		this._phoneSubscriptions = [];
	}

	setOuterPhone = phone => {
		this.Phone(ko.unwrap(phone));
		
		this._phoneSubscriptions.push(
			this.Phone.subscribe(v => {
				if (ko.isWritableObservable(phone)) {
					phone(v);
				}
			})
		);
	}

	dispose () {
		this._phoneSubscriptions.forEach(s => s.dispose());
	}

	validationArray ({ action }) {
		let arr = [];

		if (action === actions.check) {
			arr = arr.concat(this.Phone);
		}

		if (action === actions.verify) {
			arr = arr.concat([
				this.Phone,
				this.Code,
			]);
		}

		return arr;
	}
}
